import { Type } from '../../../../../redux/Transaction/helper';
import { PermissionKey } from './PermissionKey';

export const PermissionKeysByType = {
    [Type.sale_invoice]: [PermissionKey.sale, PermissionKey.sale_invoice],
    [Type.sale_credit_note]: [PermissionKey.sale, PermissionKey.sale_credit_note],
    [Type.opening_invoice]: [PermissionKey.sale, PermissionKey.sale_invoice],
    [Type.opening_sale_credit_note]: [PermissionKey.sale, PermissionKey.sale_credit_note],
    [Type.sale_order]: [PermissionKey.sale, PermissionKey.sale_order],
    [Type.sale_delivery_order]: [PermissionKey.sale, PermissionKey.sale_delivery_order],
    [Type.sale_payment]: [PermissionKey.sale, PermissionKey.sale_payment],
    [Type.sale_refund]: [PermissionKey.sale, PermissionKey.sale_payment],
    [Type.sale_quote]: [PermissionKey.sale, PermissionKey.sale_quote],

    [Type.purchase_order]: [PermissionKey.purchase, PermissionKey.purchase_order],
    [Type.purchase_goods_received_note]: [PermissionKey.purchase, PermissionKey.purchase_goods_received_note],
    [Type.purchase_bill]: [PermissionKey.purchase, PermissionKey.purchase_bill],
    [Type.purchase_credit_note]: [PermissionKey.purchase, PermissionKey.purchase_credit_note],
    [Type.purchase_payment]: [PermissionKey.purchase, PermissionKey.purchase_payment],
    [Type.purchase_refund]: [PermissionKey.purchase, PermissionKey.purchase_payment],
    [Type.opening_bill]: [PermissionKey.purchase, PermissionKey.purchase_bill],
    [Type.opening_purchase_credit_note]: [PermissionKey.purchase, PermissionKey.purchase_credit_note],

    [Type.bank_income]: [PermissionKey.bank, PermissionKey.bank_income],
    [Type.bank_expense]: [PermissionKey.bank, PermissionKey.bank_expense],
    [Type.bank_transfer]: [PermissionKey.bank, PermissionKey.bank_transfer],

    [Type.stock_adjustment]: [PermissionKey.stock, PermissionKey.stock_adjustment],
    [Type.stock_transfer]: [PermissionKey.stock, PermissionKey.stock_transfer],
    [Type.stock_value]: [PermissionKey.stock, PermissionKey.stock_value],
    [Type.tax_deemed_payment]: [PermissionKey.accounting, PermissionKey.accounting_deemed_payment],
    [Type.journal_entry]: [PermissionKey.accounting, PermissionKey.accounting_journal_entry],
    [Type.contra]: [PermissionKey.accounting, PermissionKey.accounting_contra],
};
